import React from 'react'

import './editUserDetails.css'

const EditUserDetails = ({id, userData}: any) => {
    
  return (
    <div>EditUserDetails</div>
  )
}

export default EditUserDetails